import React, { Component } from "react";
import fire from '../fire';
import Loading from "../SiteLayout/Loading";
import ResponsiveEmbed from "react-responsive-embed";
import { Grid, Header } from "semantic-ui-react";

class TafsirSurahTafsirViewer extends Component {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount(){
        const currentLessonNumber = window.location.pathname.split("/")[2];
        const response = fire.firestore().collection("tajweed").doc(currentLessonNumber);
        
        response.get().then((querySnapshot) => {
            this.setState(querySnapshot.data()); 
            this.setState({isLoading: false})     
        });
    }

    render(){
        return(
            this.state.isLoading ?
                <Loading />
            :
            <Grid stackable textAlign="center" verticalAlign="middle">
                {
                    this.state.articleId !== undefined ?
                        <Grid.Column width={15}>
                            <Header content="Read our Tajweed Lesson!" icon="book"/>
                            <iframe title={this.state.articleId} width="100%" height="1000px" src={`https://drive.google.com/file/d/${this.state.articleId}/preview`} frameBorder="0"></iframe>
                        </Grid.Column>
                    :
                        null
                }
                {
                    this.state.youtubeId !== undefined ?
                        <Grid.Column mobile={14} tablet={12} computer={10}>
                            <Header content="Watch our video!" icon="youtube"/>
                            <ResponsiveEmbed src={`https://www.youtube.com/embed/${this.state.youtubeId}`} allowFullScreen />
                        </Grid.Column>
                    :
                        null
                }
                {
                    this.state.soundCloudId !== undefined ?
                        <Grid.Column width={15}>
                            <Header content="Listen to our Podcast!" icon="file audio"/>
                            <iframe title="SoundCloudEmbed" width="100%" height="166" scrolling="no" frameBorder="no" allow="autoplay" src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${this.state.soundCloudId}&color=%23990000&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true`}></iframe>
                        </Grid.Column>
                    :
                        null
                }
            </Grid>
        );
    }
}
export default TafsirSurahTafsirViewer;